import React, { Component } from "react";
import QuotePdfDisplay from "./quotePdfDisplay";

// Has to be a class component in order to work with react-to-print
export class QuotePdf extends Component {
  render() {
    return <QuotePdfDisplay {...this.props} />;
  }
}
